import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  makeStyles,
  Paper,
  Chip,
  Dialog,
  Typography,
} from "@material-ui/core";
import CustomDialogTitle from "../../../common/projectsDashboard/CustomDialogTitle";
import ExceptionDetails from "../../../common/sasl/batch/viewBatchQualityEvents/ExceptionDetails";
import StatusTextDispaly from "../../../common/models/status/DeliveryCompleted";
import getColor from "../../../common/sasl/models/status/statusColors";

const useStyles = makeStyles((theme) => ({
  table: {
    // minWidth: 650,
    maxWidth: "100%",
  },
  statusButton: {
    backgroundColor: "#670c0c", // Maroon color for "Goods received"
    color: "white",
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 2),
    textTransform: "none",

    fontWeight: 500,
  },
  tableContainer: {
    margin: theme.spacing(2, 0),
    border: "1px solid #ddd",
  },
  tableHead: {
    backgroundColor: "#f5f5f5",
  },
  actionButton: {
    borderColor: "#000",
    textTransform: "none",
    borderRadius: "50px",
  },
  centerCell: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const batches = [
  { number: "GTX776F", status: "Goods received" },
  { number: "GTX777F", status: "Goods received" },
  { number: "GTX778F", status: "Goods received" },
  { number: "GTX779F", status: "Goods received" },
];

const BatchTable = ({ data, plantCode }) => {
  const classes = useStyles();

  const [openDialogBox, setDialogBox] = useState({
    viewQualityEvents: false,
  });
  const [selectedBatch , setSelectedBatch] = useState(null)
  const handleOpenCloseDialogBox = (type, batch) => {
    if (type === "viewQualityEvents") {
      setDialogBox({
        viewQualityEvents: !openDialogBox.viewQualityEvents,
      });
      setSelectedBatch(batch)
    }
  };
  // const batchDetails = { batchNumber: "A301210" };

  if (data?.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center", // Horizontally center the CircularProgress
          alignItems: "center", // Vertically center the CircularProgress
          height: "50px", // Optional: Set a height to vertically center the loader
          border: "2px solid #000",
          // backgroundColor: "#FFF0F0",
          width: "100%",
        }}
      >
        <Typography style={{ textAlign: "center" }}>
          No Records Found
        </Typography>
      </div>
    );
  }

  return (
    <React.Fragment>
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table className={classes.table} aria-label="batch table">
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell>
              <strong>Batch number</strong>
            </TableCell>
            <TableCell align="center">
              <strong>Batch status</strong>
            </TableCell>
            <TableCell align="center">
              <strong>Action</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((batch) => (
            <TableRow key={batch?.vendorBatchNumber}>
              <TableCell>{batch?.vendorBatchNumber}</TableCell>
              <TableCell
              // className={classes.centerCell}
              >
                {/* <Chip
                  className={classes.statusButton}
                  label={batch?.batchStatusText}
                ></Chip> */}
                <StatusTextDispaly
                  statusText={batch?.batchStatusText}
                  bgColor={getColor(batch?.statusID)}
                />
              </TableCell>
              <TableCell lassName={classes.centerCell} align="center">
                <Button
                  className={classes.actionButton}
                  variant="outlined"
                  onClick={() => handleOpenCloseDialogBox("viewQualityEvents", batch)}
                >
                  View quality events
                </Button>
                
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      </TableContainer>
      {openDialogBox.viewQualityEvents && selectedBatch &&
        <Dialog open={openDialogBox.viewQualityEvents} fullScreen>
    <CustomDialogTitle
      onBackClick={() =>
        handleOpenCloseDialogBox("viewQualityEvents",null)
      }
      title={"View quality events"}
    />
    <ExceptionDetails
      batchDetails={{
        vendorBatchNumber: selectedBatch.vendorBatchNumber,
        batchStartDate: selectedBatch.scheduledStartDate,
        vendorPlant: plantCode,
      }}
    />
      </Dialog>
      }
    
      </React.Fragment>
  );
};

export default BatchTable;
